import { FC } from 'react';
import { MdClose } from 'react-icons/md';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectQuiz } from 'store/quiz/quizSelectors';
// Components
import Dialog from 'components/Dialog';
import EditorContent from 'components/EditorContent';
// Utilities
import { renderWithVariables } from 'utilities/Utilities';

type Props = {
  onClose: () => void;
  content: string;
}

const ConsentContentDialog:FC<Props> = ({ onClose, content }) => {
  const quiz = useAppSelector(selectQuiz);

  return (
    <Dialog background="rgba(0,0,0,0.85)">
      <div className="
        flex-grow flex flex-col overflow-y-auto
        w-full h-full p-4
      ">
        <div className="
          flex flex-col
          bg-gray-200 rounded-lg w-full
        ">
          <div className="
            flex justify-between items-center
            border-b border-gray-300
            p-4
          ">
            <h2 className="flex-grow text-sm font-bold pr-2"> </h2>
            <button
              className="p-2 -mr-2"
              onClick={onClose}
            ><MdClose /></button>
          </div>
          <EditorContent html={renderWithVariables(content, { organizationName: quiz.organization })} />
        </div>
      </div>
    </Dialog>
  )
}

export default ConsentContentDialog;
